var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{radioButton: true, active: _vm.val, disabled: _vm.disabled},on:{"click":_vm.emitNewValue}},[(_vm.val)?_c('svg',[_c('polyline',{attrs:{"points":"3,7 6,10 12,4"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }